<template>
    <div>
        <v-card :loading="loading">
            <v-card-title>
                {{ typeCash=='open'? 'Apertura de caja':'Cierre de caja' }}
            </v-card-title>
            <v-card-text>
                <v-form @submit.prevent="openCash" ref="formOpenCash" lazy-validation>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                :label="`Monto de ${typeCash=='open'?'apertura':'cierre'} en ${money} *`"
                                outlined
                                dense
                                type="number"
                                v-model="cashByUser"
                                :rules="[rules.required]"
                                :error="errors['cash_by_user'] ? true :false"
                                :error-messages="errors['cash_by_user'] ? errors['cash_by_user'][0] : ''"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-btn
                                color="primary"
                                type="submit"
                                block
                                :loading="loading"
                            >{{ typeCash=='open'?'Abrir caja':'Cierre de caja' }}</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <!-- dialog -->
        <v-dialog
            v-model="dialogPrint"
            width="250"
            persistent
        >
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-btn
                        color="primary"
                        block
                        x-large
                        target="_blank"
                        :href="`/admin/print-cash/${cashId}`"
                    >Imprimir</v-btn>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="closeModal"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            loading: false,
            // form
            cashByUser: '',
            // validations
            rules: {
                required: value => !!value || 'Requerido.'
            },
            errors: {},
            dialogPrint: false,
            cashId: ''
        }
    },
    props: ['typeCash', 'money'],
    methods: {
        async openCash() {
            if (this.$refs.formOpenCash.validate()) {
                this.loading = true
                await axios.post('/admin/cashier/open-cash', {cash_by_user: this.cashByUser, type: this.typeCash})
                .then((response) => {
                    if (response.data[1] == 'ok') {
                        this.cashId = response.data[0]
                        this.$notify.success(`Caja ${this.typeCash=='open'?'aperturada':'cerrada'} con exito.`);
                        this.$emit('close-modal')
                        this.dialogPrint = true
                    }
                    this.loading = false
                })
                .catch((error) => {
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error del servidor, inténtalo de nuevo más tarde.');
                    }
                    this.loading = false
                })
            }
        },
        closeModal() {
            this.dialogPrint = false
            window.location.reload()
        }
    }
}
</script>